import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { BuildInfo } from '@core/build/build-info.model';
import { BuildInfoStore } from '@core/build/build-info.store';

@Injectable({
    providedIn: 'root',
})
export class VersionCheckService {
    private http = inject(HttpClient);
    private buildInfoStore = inject(BuildInfoStore);
    private currentBuildId = this.buildInfoStore.snapshot.buildId;
    private appVersion = this.buildInfoStore.snapshot.version ?? '';

    requireUpdate = new BehaviorSubject<boolean>(false);
    requireUpdateChanges$ = this.requireUpdate.asObservable();

    stopChecking = false;

    public initVersionCheck(url: string) {
        if (environment.production) {
            // Initially check after 30 seconds
            setTimeout(() => {
                this.checkVersion(url);
            }, 30000);

            // Periodically check every 15 minutes
            setInterval(() => {
                if (!this.stopChecking) {
                    this.checkVersion(url);
                }
            }, 1000 * 60 * 15);
        }
    }

    private checkVersion(url: string) {
        const headers = new HttpHeaders({ ignoreProgressBar: '' });

        this.http
            .get<BuildInfo>(`${url}?t=${Date.now()}`, { headers })
            .pipe(first())
            .subscribe({
                next: response => {
                    const buildId = response.buildId;

                    if (!buildId) {
                        this.stopChecking = true;
                        return;
                    }

                    if (this.currentBuildId !== buildId) {
                        this.requireUpdate.next(true);
                    }
                },
                error: err => {
                    console.error(err, 'Could not get version');
                }
            });
    }

    get version(): string {
        return this.appVersion;
    }
}
